import { TokenRequest } from '@/types/openid';
import { auth } from '@/constants';
import { tokensApi } from '@/services/api/tokens';

const tokenRequestParams = (
  code: string,
  codeVerifier: string,
): TokenRequest => {
  const clientId = auth.CLIENT_ID;
  const redirectUri = auth.Url.redirectUri;

  return {
    grant_type: 'authorization_code',
    scope: auth.SCOPES.join(' '),
    code,
    redirect_uri: redirectUri,
    client_id: clientId,
    client_assertion_type: auth.PUBLIC_CLIENT_ASSERTION_TYPE,
    code_verifier: codeVerifier,
  };
};

export const fetchTokenResponse = async (
  code: string,
  codeVerifier: string,
) => {
  const tokenResponse = await tokensApi.post(
    tokenRequestParams(code, codeVerifier),
  );
  return tokenResponse;
};
